import { ReportEquipmentParams } from "@/types/reportEquipment";
import { Client } from "./client";
import { ReadAllReportEquipmentForReportReply, ReportEquipmentReply } from "@/backend/express/controllers/reportEquipmentController";
import { FusaReply } from "@/types/replyTypes";

export class ReportEquipmentController {
  client: Client;

  constructor(client?: Client) {
    this.client = client || new Client();
  }

  public async readAllReportEquipmentForReport(reportId: string): Promise<ReadAllReportEquipmentForReportReply> {
    return this.client.read(`/api/reportEquipment/readAllForReport/${reportId}`);
  }

  public async importEquipmentFromProcedure(procedureId: string, reportId: string): Promise<ReadAllReportEquipmentForReportReply> {
    return this.client.create(`/api/reportEquipment/importFromProcedure`, { procedureId, reportId });
  }

  public async updateReportEquipment(reportEquipment: ReportEquipmentParams): Promise<ReportEquipmentReply> {
    return this.client.update(`/api/reportEquipment`, reportEquipment);
  }

  public async deleteReportEquipment(reportEquipmentId: string): Promise<FusaReply> {
    return this.client.delete(`/api/reportEquipment/${reportEquipmentId}`);
  }
}
